@if (state(); as s) {
  <div
    class="subscription-banner"
    [class.subscription-banner--past-due]="s === 'past_due'"
    [class.subscription-banner--cancelled]="s === 'cancelled'"
    role="status"
    >
    <mat-icon class="subscription-banner__icon">
      {{ s === 'past_due' ? 'schedule' : 'block' }}
    </mat-icon>
    <span class="subscription-banner__message">
      @if (s === 'past_due') {
        Your subscription payment is overdue. Restore access by updating your billing.
      }
      @if (s === 'cancelled') {
        Your subscription is cancelled. Renew to keep using ViTails.
      }
    </span>
    <button
      mat-flat-button
      class="subscription-banner__cta"
      type="button"
      (click)="manage()"
      >
      Manage subscription
    </button>
  </div>
}
